import { DependantsFields } from 'src/non-financial-data/v2/sections/fields/DependantsFields';
import IndividualEntityForm from '../IndividualEntityForm';

export default function DependantsV2() {
  return (
    <IndividualEntityForm title="Dependants">
      <DependantsFields />
    </IndividualEntityForm>
  );
}
